<template>
  <div>
    <BaseInfo :formData="formData" ref="baseinfo"
              :alreadyDone="alreadyDone"
              :conditionList="conditionList"
              :regionListOri="regionList"
    ></BaseInfo>

    <save-and-cancel v-if="!alreadyDone" @save="save" @cancel="cancel" v-p="{api:'project/saveBaseInfo'}">
    </save-and-cancel>
  </div>
</template>
<script>
  import SaveAndCancel from 'components/SaveAndCancel/index'
  import {saveBaseInfo} from "../../../../../api/project";
  import BaseInfo from '../../components/BaseInfo'
  import {addCondition} from "../../../../../api/project";
  import {formatDateTime} from "../../../../../utils/format";

  export default {
    name:'BaseAdd',
    components: {
      SaveAndCancel,
      BaseInfo
    },
    data() {
      return {
        regionList:[],
        conditionList:{},
        alreadyDone:false,
        projectOwner: [],
        cityList: [],
        projectCompany: [],
        projectHeatingModel: [],
        modeList: [],
        formData: {
          projectName: '',
          projectCityCode: '',
          projectCityName: '',//城市名称
          projectRegionCode:'',
          projectAddress: '',
          projectVacancyDay: '',  //空置天数
          projectContractBegin: '',
          projectContractEnd: '',
          projectContractCycle: '', //租赁年限
          projectLon: '',//经度
          projectLat: '',//纬度
          projectArea: '',//项目面积
          projectPublicArea: '',//公区面积
          projectBuildingNum: '',
          projectDescription: '',
          // projectState:'',
          projectCooperationModel: '', //合作模式
          projectCompanyCode: '',//结算公司编码
          projectCompanyName: '',//结算公司名称
          projectCarPortNum: '',
          projectWaterType: '',
          projectWaterPrice: '',
          projectPowerType: '',
          projectPowerPrice: '',
          projectOpeningTime: '',
          projectDecorateTime: '',
          ownerId: '',
          projectIntro: '',
          remark: '',
          heatingMode: '',
          houseTypeNum: '',   //房型数
          houseNum: '',  //房间数
          addressValid: false,
          receivedContract: '',
          dateList: []
        },
      }
    },
    computed: {
    },
    methods: {
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)
      },
      save() {
        this.formData.projectCompanyName = ''
        if(!this.formData.projectAddress){
          this.formData.addressValid=true
        }
        this.$refs['baseinfo'].$refs['form'].validate(bool => {

          if (bool) {
            this.formData.projectCompanyName = this.$refs['baseinfo'].projectCompanyMap[this.formData.projectCompanyCode + '']
            this.formData.projectContractBegin = this.format(this.formData.dateList[0])
            this.formData.projectContractEnd = this.format(this.formData.dateList[1])
            this.formData.projectOpeningTime=this.format(this.formData.projectOpeningTime)
            this.formData.projectDecorateTime=this.format(this.formData.projectDecorateTime)
            saveBaseInfo(this.formData).then(res => {
              this.alreadyDone=true
              this.$Message.success('项目基本信息添加成功')
              this.$emit('done',res.data.projectFid,this.formData.projectBuildingNum)
            }).catch(error=>{})
          }
          else {
            this.$Message.info('请检查填写内容！')
            return
          }
        })

      },
      cancel() {
        if(this.alreadyDone){
          this.$Message.info('项目基本信息已保存')
          return
        }
        this.formData = {
          projectName: '',
          projectCityCode: '',
          projectCityName: '',//城市名称
          projectRegionCode:'',
          projectAddress: '',
          projectVacancyDay: '',  //空置天数
          projectContractBegin: '',
          projectContractEnd: '',
          projectContractCycle: '', //租赁年限
          projectLon: '',//经度
          projectLat: '',//纬度
          projectArea: '',//项目面积
          projectPublicArea: '',//公区面积
          projectBuildingNum: '',
          projectDescription: '',
          // projectState:'',
          projectCooperationModel: '', //合作模式
          projectCompanyCode: '',//结算公司编码
          projectCompanyName: '',//结算公司名称
          projectCarPortNum: '',
          projectWaterType: '',
          projectWaterPrice: '',
          projectPowerType: '',
          projectPowerPrice: '',
          projectOpeningTime: '',
          projectDecorateTime: '',
          ownerId: '',
          projectIntro: '',
          remark: '',
          heatingMode: '',
          houseTypeNum: '',   //房型数
          houseNum: '',  //房间数
          addressValid:false,
          dateList:[]
        }
        this.$refs['baseinfo'].$refs['form'].resetFields()

      },
    },
    created(){

      addCondition().then(res => {
        this.conditionList=res.data
      }).catch(error=>{})

    },
  }
</script>

<style scoped>
  .time-width {
    width: 250px;
  }

  .redline {
    border: 1px solid red;
  }

  .map-container {
    width: 50%;
    height: 180px;
    margin-bottom: 16px;
    margin-left: 150px;
    /*background-color: #6d7380;*/
  }

  .input-long300 {
    width: 300px;
  }

  .input-long {
    width: 200px;
  }

  .select-long2 {
    width: 300px;
  }

  .select-long {
    width: 200px;
  }

  .select-width {
    width: 100px;
  }

  .select-width2 {
    width: 150px;
  }

  .input-short {
    width: 100px;
  }

</style>
